import { seriesSvgMulti } from '@d3fc/d3fc-series';
import { priceLine } from './priceLine';
import { getPriceAreaSeries } from 'widgets/symbolTile/components/chart/series/priceArea';
import {
    highPricePoint,
    lastPricePoint,
    lowPricePoint,
} from 'widgets/symbolTile/components/chart/series/pricePoints';

export const getSymbolTilesSeries = (gradientId: string, yStart: number) =>
    seriesSvgMulti().series([
        priceLine,
        getPriceAreaSeries(gradientId, yStart),
        highPricePoint,
        lowPricePoint,
        lastPricePoint,
    ]);
